/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IEveMap contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum searchRadiusUnit {
    mi = 'mi',
    km = 'km'
}

export interface IEveMapConfig extends Msdyn365.IModuleConfig {
    heading?: IHeadingData;
    pushpinOptions?: IPushpinOptionsData;
    className?: string;
    clientRender?: boolean;
    useChannelMfr?: boolean;
    autoSuggestionEnabled?: boolean;
    autoSuggestOptions?: IAutoSuggestOptionsData;
    searchRadiusUnit?: searchRadiusUnit;
    lookupRadius: number;
    pageLength: number;
    defaultLatitudeValue: number;
    defaultLongitudeValue: number;
}

export interface IEveMapResources {
    searchPlaceholderText: string;
    searchButtonAriaLabel: string;
    searchInputAriaLabel: string;
    seeAllStoresText: string;
    milesShortText: string;
    kilometersShortText: string;
    contactText: string;
    emptyLocationsText: string;
    dealerCountMessage: string;
    dealerAllCountMessage: string;
    dealerCountMessageInKm: string;
    dealerDetailsText: string;
    dealerDetailsManufacturerCodeText: string;
    dealerDetailsLaborRateText: string;
    dealerDetailsDescriptionText: string;
    dealerDetailsNotesText: string;
    dealerDetailsContractCodeText: string;
    paginationPrev: string;
    paginationNext: string;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export interface IPushpinOptionsData {
    size?: number;
    color?: string;
    selectionColor?: string;
    showIndex?: boolean;
}

export interface IAutoSuggestOptionsData {
    maxResults?: number;
}

export interface IEveMapProps<T> extends Msdyn365.IModule<T> {
    resources: IEveMapResources;
    config: IEveMapConfig;
}
